import { createFileRoute } from '@tanstack/react-router';
import { LaneDetails } from '@uturn/portal/modules/lanes/pages/detail';
import z from 'zod';

const LanesLaneIdParams = z.object({
	laneId: z.coerce.number(),
});

export const Route = createFileRoute('/_protected/lanes/$laneId')({
	params: {
		parse: (rawParams) => LanesLaneIdParams.parse(rawParams),
	},
	component: LaneDetails,
});
